(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["compartir"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-share-copy]') : null;
    if (!button) return;

    try {
      await navigator.clipboard.writeText(button.dataset.shareCopy);
    } catch (error) {
      return;
    }

    const label = button.textContent;
    button.textContent = button.dataset.copiedLabel;
    setTimeout(() => {
      button.textContent = label;
    }, 2000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabla-discos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tabla-discos')) {
    customElements.define(
      'tabla-discos',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const boton = event.target.closest('[data-filtro]');
            if (!boton) return;
            const filtro = boton.dataset.filtro;
            this.querySelectorAll('[data-filtro]').forEach((b) => b.classList.toggle('is-active', b === boton));
            this.querySelectorAll('tbody tr').forEach((fila) => {
              const mats = (fila.dataset.materiales || '').split(' ');
              fila.hidden = filtro !== '' && !mats.includes(filtro);
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
